// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.app-main[data-v-078753dd] {\n\n  /*50 = navbar  */\n  height: calc(100vh - 85px);\n  width: 100%;\n  position: relative;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.fixed-header + .app-main[data-v-078753dd] {\n  padding-top: 50px;\n}\n.im[data-v-078753dd] {\n  position: fixed;\n  right: 0;\n  bottom: 10px;\n  /* border: 1px solid red; */\n  z-index: 500;\n}\n", ""]);
// Exports
module.exports = exports;
